import axios from '@/axiosConnection'
export default {
  namespaced: true,
  state: {
    items: [],
    cart: [],
    reappro: [],
    myOrders: [],
    myReappros: [],
    cartOrderId: null,
    cartNbItems: 0,
    orderNbItems: 0,
    ordersNumber: 0,
    reapprosNumber: 0,
    orderTypes:[
        {value: "Automatique", text : "Automatique"},
        {value: "Manuelle", text : "Manuelle"}
    ],
    orderStatusLabels: [
        {value: "-1", text : "Panier"},
        {value: "0", text: "Réapprovisionnement créé"},
        {value: "1", text: "Réapprovisionnement accepté"},
        {value: "2", text: "Validé"},
        {value: "3", text: "Envoyé"},
        {value: "4", text: "Reçu"},
        {value: "5", text: "Complété"},
        {value: "9", text: "Réapprovisionnement refusé"},
    ]
    ,
  },
  mutations : {
    setCart(state, cart) {
      if (cart) {
        state.cart = cart
      }
    },
    emptyCart(state){
      state.cart = []
      state.cartNbItems = 0
    },
    emptyReappro(state){
      state.reappro = []
    },
    setCartNbItems(state, cartNbItems) {
      state.cartNbItems = cartNbItems
    },
    setMyOrdersNb(state, nbOrders) {
      state.ordersNumber = nbOrders
    },
    setMyOrders(state, orders) {
      state.myOrders = orders
    },
    setMyReapprosNb(state, nbReappros) {
      state.reapprosNumber = nbReappros
    },
    setMyReappros(state, reappros) {
      if (reappros) {
        state.myReappros = reappros
      }
    },
    incrementNbItems(state) {
      state.cartNbItems ++
    },
    resetNbItems(state) {
      state.cartNbItems = 0
    }
  },
  getters: {
    getAll: state => {
      return state.items
    },
    getMyOrdersCount: state => state.ordersNumber,
    getMyOrders: state => state.myOrders,
    getOrderNbItems: state => state.orderNbItems,
    getCartOrderId: state => state.cartOrderId,
    getCartNbItems: state => state.cartNbItems,
    getMyCart: state => state.cart,
    getMyReappros: state => state.myReappros,
    getMyReapprosCount: state => state.reapprosNumber,
    getItem: state => id => state.items.find(item => item.id == id),
    getMyItem: state => id => state.myOrders.find(item => item.id == id),
    getOrderStatusLabels: state => state.orderStatusLabels,
    getOrderTypes: state => state.orderTypes,
    getOrderStatusLabel: state => status => state.orderStatusLabels.find(item => item.value == status),
    getOrderType: state => type => state.orderTypes.find(item => item.value == type),
  },
  actions: {
    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   boolean wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'order',
        api_data_path: 'orders',
        namespace: 'order'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'order',
        namespace: 'order',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    getMyOrdersCount: (context, wait = false) => {
      return new Promise(function (resolve, reject) {
        if (wait == false && context.state.ordersNumber && context.state.ordersNumber.length) {
          resolve()
        }
        axios.get('order/current/count')
          .then(response => {

            context.commit('setMyOrdersNb', response.data);

            resolve()
          })
          .catch(error => {
            // toastr.error("Le chargement de la liste a échoué")
            reject()
          })
      })
    },
    getMyOrders: (context, wait = false) => {
      return new Promise(function (resolve, reject) {
        axios.get('order/current')
          .then(response => {
            context.commit('setMyOrders', response.data);

            resolve()
          })
          .catch(error => {
            // toastr.error("Le chargement de la liste a échoué")
            reject()
          })
      })
    },
    getMyReapprosCount: (context, wait = false) => {
      return new Promise(function (resolve, reject) {
        if (wait == false && context.state.reapprosNumber && context.state.reapprosNumber.length) {
          resolve()
        }

        axios.get('order/reappro/current/count')
          .then(response => {

            context.commit('setMyReapprosNb', response.data);

            resolve()
          })
          .catch(error => {
            // toastr.error("Le chargement de la liste a échoué")
            reject()
          })
      })
    },
    getMyReappros: (context, wait = false) => {
      return new Promise(function (resolve, reject) {
        if (wait == false && context.state.reappro && context.state.reappro.length) {
          resolve()
        }
        axios.get('order/reappro/current')
          .then(response => {

            if(response.data == 'no-reappro'){
              context.commit('emptyReappro');
            }else{
              context.commit('setMyReappros', response.data);
            }

            resolve()
          })
          .catch(error => {
            // toastr.error("Le chargement de la liste a échoué")
            reject()
          })
      })
    },
    getMyCart: (context, wait = false) => {
      return new Promise(function (resolve, reject) {
        if (wait == false && context.state.cart && context.state.cart.length) {
          resolve()
        }
        axios.get('order/cart/current')
        .then(response => {

          if(response.data == 'no-cart'){
            context.commit('emptyCart');
          }else{
            context.commit('setCart', response.data);

            let nbItems = 0;
            
            if(response.data.lines){
              for(var j = 0; j < response.data.lines.length; j++){
                nbItems += response.data.lines[j].quantity;
              }
            }
            context.commit('setCartNbItems', nbItems);
          }

          resolve()
        })
        .catch(error => {
          // toastr.error("Le chargement de la liste a échoué")
          reject()
        })
      })
    },
    setMyOrdersNb(context, nb){
      context.commit('setMyOrdersNb', nb)
    },
    setMyOrders(context, orders){
      context.commit('setMyOrders', orders)
    },
    setMyReappros(context, reappros){
      context.commit('setMyReappros', reappros)
    },
    setMyReapprosNb(context, nb){
      context.commit('setMyReapprosNb', nb)
    },
    incrementNbItems(context){
      context.commit('incrementNbItems')
    },
    emptyCart(context){
      context.commit('emptyCart')
    },
    emptyReappro(context){
      context.commit('emptyReappro')
    },
    setCartNbItems(context, nb){
      context.commit('setCartNbItems', nb)
    },
     addItem(context, item) {
       let params = {
         api_url: 'order',
         namespace: 'order',
         item: item
       }
       context.dispatch('addItem', params, {
         root: true
       })
     },
     saveItem(context, item) {
       let params = {
         api_url: 'order',
         namespace: 'order',
         item: item
       }
       context.dispatch('saveItem', params, {
         root: true
       })
     },
     deleteItem(context, id) {
       let params = {
         api_url: 'order',
         namespace: 'order',
         id: id
       }
       context.dispatch('deleteItem', params, {
         root: true
       })
     }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/order.js